import { render, staticRenderFns } from "./BlogCardCover.vue?vue&type=template&id=3f8ea539"
import script from "./BlogCardCover.vue?vue&type=script&lang=js"
export * from "./BlogCardCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports